import React from "react";
import { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import HlthtekQR from "../../assets/img/hlthtek-qr.png";
import { CheckToken } from "../login/AccessToken";
import { useEffect } from "react";
import QRCode from "react-qr-code";
import axios from "axios";
import { Card, Typography, Grid, CardContent } from "@mui/material";
import { arr, accessMapping } from "./constants";
import { toast } from "react-toastify";
import HTMateIcon from "../../assets/images/gallery/B-T-HTMATE.svg";
import HTBridgeIcon from "../../assets/images/gallery/B-T-BRIDGE.svg";
import HTHrpIcon from "../../assets/images/gallery/B-T-HTHRP.svg";
import { Avatar } from "antd";
import { Box } from "@mui/system";
import { usePermissions } from "../login/PermissionContext";
function HlthtekDemo({ setBrandingData }) {
  const history = useHistory();
  const [refreshList, setRefreshList] = useState("");
  const [title, setTitle] = useState("");
  const [isAbdmEnabled, setIsAbdmEnabled] = useState();
  const [currentURL, setCurrentURL] = useState(window.location.href);
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const [dataLoaded, setDataLoaded] = useState(false);

  const [roleType, setRoleType] = useState(
    sessionStorage.getItem("roleType") || ""
  );

  const allowedRoles = [
    "facility user",
    "user",
    "lab user",
    "pharmacy user",
    "facility admin",
    "customer admin",
  ];

  const fetchBrandingData = () => {
    const payload = {
      // functionality: "branding",
      // segment: "images",
      // config_type:"configuration",
      bucket_type: "license",
      bucket_category: "conf",
      file_key: "",
      facility: false,
    };

    axios
      .post(`${REACT_APP_BACKEND_ROUTE_URL}get_facility_branding/`, payload, {
        headers,
      })
      .then((res) => {
        if (res.data.status === "Success") {
          setBrandingData(res.data?.data);
          console.log("branding..demo", res.data?.data);
        } else if (res?.data?.message === "No files found.") {
          toast.info("Branding information not yet provided");
        } else {
          // toast.error("Error fetching branding data");
          console.log("Error:", res.data.message);
        }
      })
      .catch((err) => {
        console.log("Error fetching branding data:", err);
        toast.error("Error fetching branding data");
      });
  };

  useEffect(() => {
    if (authToken && roleType && allowedRoles.includes(roleType)) {
      fetchBrandingData();
    }
  }, []);
  const [filteredItems, setFilteredItems] = useState([]);
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  useEffect(() => {
    if (
      sessionStorage.getItem("accessToken") == undefined &&
      sessionStorage.getItem("accessToken") == null
    ) {
      history.push("/login");
    }
  }, []);
  const updateList = () => {
    setRefreshList(true);
  };

  const Token = () => {
    const check = CheckToken();
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };

  const navigate = (route) => {
    console.log(route);
    history.push(`/${route}`);
  };

  const handleIconClick = (e) => {
    e.stopPropagation();
  };

  useEffect(() => {
    if (
      sessionStorage.getItem("roleType") !== "admin" &&
      authToken !== undefined &&
      authToken.length > 0
    ) {
      axios
        .get(`${REACT_APP_BACKEND_ROUTE_URL}get_logged_in_user_info/`, {
          headers: headers,
        })
        .then((res) => {
          if (res.data.status === "Success") {
            setIsAbdmEnabled(res.data.abdm_enabled);
            console.log(res.data);
            setTitle(res.data.facility_name);
            // sessionStorage.setItem(
            //   "subscription_type",
            //   res.data.subscription_type
            // );

            const {
              facility_address_line_1,
              facility_address_line_2,
              facility_address_line_3,
            } = res.data;

            const addressLines = {
              facilityAddressLine1: facility_address_line_1,
              facilityAddressLine2: facility_address_line_2,
              facilityAddressLine3: facility_address_line_3,
            };

            Object.entries(addressLines).forEach(([key, value]) =>
              sessionStorage.setItem(key, value ?? "")
            );
            sessionStorage.setItem("isAbdmEnabled", res.data.abdm_enabled);
            sessionStorage.setItem("isEmailEnabled", res.data.email_enabled);
            sessionStorage.setItem("isAiEnabled", res.data.ai_enabled);
            sessionStorage.setItem(
              "facility_display_name",
              res.data.facility_name
            );
            let allowedPaths = [];
            if (
              sessionStorage.getItem("roleType") === "lab user" ||
              sessionStorage.getItem("roleType") === "pharmacy user"
            ) {
              allowedPaths = accessMapping[sessionStorage.getItem("roleType")];
            } else {
              // Fetch allowed paths based on the role and subscription type
              allowedPaths =
                accessMapping[sessionStorage.getItem("roleType")]?.[
                  res.data.subscription_type
                ] || [];
            }
            console.log("Allowed Paths", allowedPaths);
            // Filter the menu items based on the allowed paths
            const items = arr.filter((item) => allowedPaths.includes(item.id));
            console.log("Items", items);
            setFilteredItems(items);
            setDataLoaded(true);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [authToken]);

  console.log(currentURL);
  const permissions = usePermissions();
  console.log("permissions", permissions);
  console.log("filtered Items", filteredItems);
  console.log("Data Loaded", dataLoaded);
  return (
    <div>
      <Grid container spacing={2} alignItems="center" justifyContent="center">
        {/* Title */}
        <Grid item xs={12}>
          <Typography variant="h3" textAlign="center">
            {title}
          </Typography>
        </Grid>
        <Grid
          item
          xs={4}
          container
          direction="column"
          justifyContent="left"
          // spacing={3}
          alignItems="center"
          sx={{ paddingLeft: { xs: "0.5rem", sm: "1rem" } }} // Adjust padding for responsiveness
        >
          <Grid item>
            <Box
              component="img"
              src={
                sessionStorage.getItem("subscriptionType") ===
                  "EHR/HMIS Service With ABDM Connector - HIU/HIP" ||
                sessionStorage.getItem("subscriptionType") ===
                  "EHR/HMIS Service Without ABDM Connector"
                  ? HTMateIcon
                  : sessionStorage.getItem("subscriptionType") ===
                      "ABDM Connector/Adaptor - HIU/HIP" ||
                    sessionStorage.getItem("subscriptionType") ===
                      "ABDM Connector/Adaptor - HIU" ||
                    sessionStorage.getItem("subscriptionType") ===
                      "ABDM Connector/Adaptor - HIP"
                  ? HTBridgeIcon
                  : HTHrpIcon
              }
              alt="HT Mate Icon"
              sx={{
                borderRadius: "5px",
                // width: { xs: 50, sm: 60, md: 80, lg: 100 }, // Responsive width
                height: { xs: 50, sm: 60, md: 80, lg: 100 }, // Responsive height
                width: { xs: 150, sm: 210, md: 255, lg: 300 }, // Responsive width
              }}
            />
          </Grid>

          {/* <Grid item>
            <Typography variant="body1" fontSize="1rem" color="black">
              <b>
                {sessionStorage.getItem("subscriptionType") ===
                  "EHR/HMIS Service With ABDM Connector - HIU/HIP" ||
                sessionStorage.getItem("subscriptionType") ===
                  "EHR/HMIS Service Without ABDM Connector"
                  ? "HTMATE"
                  : sessionStorage.getItem("subscriptionType") ===
                      "ABDM Connector/Adaptor - HIU/HIP" ||
                    sessionStorage.getItem("subscriptionType") ===
                      "ABDM Connector/Adaptor - HIU" ||
                    sessionStorage.getItem("subscriptionType") ===
                      "ABDM Connector/Adaptor - HIP"
                  ? "HTBRIDGE"
                  : "HTHRP"}
              </b>
            </Typography>
          </Grid> */}
        </Grid>
        <Grid
          item
          xs={8}
          container
          direction="column"
          justifyContent="flex-end"
          alignItems="flex-end"
          sx={{ paddingRight: { xs: "1rem", sm: "2rem" } }} // Adjust padding for responsiveness
        >
          {/* <Grid item>
            <Typography variant="body1" fontSize="1rem" color="black">
              <b>Name: {sessionStorage.getItem("name")}</b>
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="body1" fontSize="1rem" color="black" mt={1}>
              <b>Facility Name: {title}</b>
            </Typography>
          </Grid> */}
          {/* <Grid item>
            <Typography variant="body1" fontSize="1rem" color="black">
              <b>
                Subscription Type: {sessionStorage.getItem("subscriptionType")}
              </b>
            </Typography>
          </Grid> */}
        </Grid>
      </Grid>

      {dataLoaded && filteredItems.length > 0 ? (
        <Grid
          container
          spacing={3}
          sx={{
            p: { xs: 1, sm: 2, md: 3 }, // Responsive padding left/right
            width: "80%",
            margin: "20px auto",
            justifyContent: "center", // Center the grid container
            boxShadow: 3, // Add a shadow for card styling
            borderRadius: 2, // Rounded corners
          }}
        >
          {filteredItems.map((item) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={3}
              key={item.id}
              onClick={() => navigate(item.path)}
              sx={{
                padding: "24px",
                cursor: "pointer", // Cursor pointer for click action
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Card
                sx={{
                  width: "100%",
                  height: { xs: "170px", sm: "180px" }, // Set a fixed height for uniformity
                  display: "flex",
                  justifyContent: "center",
                  boxShadow: 3, // Add a shadow for card styling
                  borderRadius: 2, // Rounded corners
                  transition: "transform 0.3s ease", // Smooth hover effect
                  backgroundColor: "#21cdc0",
                  padding: 2,
                  "&:hover": {
                    transform: "scale(1.05)",
                    backgroundColor: "#003366", // Slight zoom on hover
                  },
                }}
              >
                <CardContent
                  sx={{
                    textAlign: "center", // Center the content inside the card
                  }}
                >
                  <div
                    style={{
                      marginBottom: "2rem",
                    }}
                  >
                    {item.icon}
                  </div>

                  <Typography
                    variant="h6"
                    sx={{ color: "white", textAlign: "center" }}
                  >
                    {item.name}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      ) : (
        <Typography variant="h3" textAlign="center">
          No Entitlement
        </Typography>
      )}
    </div>
  );
}

export default HlthtekDemo;

